<template>
  <div>
    <Form :ref="'form'+current" :model="form" :rules="rules" :label-width="165">
      <Divider orientation="left">{{type}}材料</Divider>
      <Row :gutter="16">
        <Col span="24">
        <FormItem label="退回原因" prop="supplementaryMaterialDescription">
          <div class="description" v-if="type=='档案'">
            {{form.filesVerificationBackReason}}
          </div>
          <div class="description" v-if="type=='最高学历'">
            {{form.educationVerificationBackReason}}
          </div>
          <div class="description" v-if="type=='专科学历'">
            {{form.juniorCollegeEducation.educationVerificationBackReason}}
          </div>
        </FormItem>
        </Col>
        <Col span="12">
        <FormItem :label="'补交材料'" prop="supplementaryMaterialOtherFileGuidList">
          <Upload ref="supplementaryMaterialOtherFileGuidList" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :show-upload-list="false" :default-file-list="form.supplementaryMaterialOtherFileGuidListPreview"
            style="flex:1;" :on-preview="handlePreview" :action="$baseURL+'/common/file/uploadfile'" :data="uploadData" :on-remove="(file, fileList)=>handleRemove(file, fileList, 'supplementaryMaterialOtherFileGuidList',true)"
            :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,'supplementaryMaterialOtherFileGuidList',true)" :on-format-error="handleFormatError">
            <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
            <Button icon="ios-camera" @click.stop="openQrCodeUpload('supplementaryMaterialOtherFileGuidList',true)">手机拍照上传</Button>
          </Upload>
          <div class="_linkdel" v-for="file in form.supplementaryMaterialOtherFileGuidListPreview" :key="file.guid">
            <div class="fileCentent" @click="handlePreview(file)">
              <Icon :type="file.name | fileType" />
              {{file.name?file.name:file.fileName}}
            </div>
            <div class="fileDel">
              <Icon type="md-close" @click="handleRemove(file, null, 'supplementaryMaterialOtherFileGuidList',true)" />
            </div>
          </div>
        </FormItem>
        </Col>

      </Row>

      <div class="bom_btn">
        <div>
          <Button type="primary" @click="next('form'+current,1)">提交</Button>
        </div>
      </div>
    </Form>

  </div>
</template>
<script>
export default {
  props: { form: { type: Object }, current: { type: Number }, type: { type: String } },
  data() {
    return {
      format: ['jpg', 'png', 'jpeg'],
      accept: 'image/*',
      count: 0, //操作
      uploadData: {},
      QRshow: false,
      loading: false,
      timer: null,
      appInfoDataType: this.$store.state.appInfoDataType,
      current_index: this.current,
      rules: {
        supplementaryMaterialOtherFileGuidList: [
          { required: true, type: 'array', message: '请上传', trigger: 'change' },
        ],
      },
      selectList: [
        { name: '是', value: 1 },
        { name: '否', value: 0 },
      ],
    }
  },
  methods: {
    //下一步
    next(name, val) {
      //下一步
      let _this = this
      this.$refs[name].validate((valid) => {
        if (!valid) {
          this.$Message.error('请将信息填写完整')
          return
        }

        _this.$emit('next', val)
      })
    },
    openQrCodeUpload(property, isArray, isReadInfo, readIdInfoAfterToView) {
      this.$emit('openQrCodeUpload', property, isArray, isReadInfo, readIdInfoAfterToView)
    },
    // submit(name) {
    //   let _this = this
    //   this.$refs[name].validate((valid) => {
    //     if (!valid) {
    //       this.$Message.error('请将信息填写完整')
    //       return
    //     }
    //     this.$Modal.confirm({
    //       title: '请确认',
    //       content: `<p>是否提交信息</p>`,
    //       okText: '是',
    //       cancelText: '否',
    //       onOk: () => {
    //         _this.$emit('submit')
    //       },
    //     })
    //   })
    // },
    //移除文件
    async handleRemove(file, fileList, property, isArray) {
      this.$emit('handleRemove', file, fileList, property, isArray)
    },
    //文件上传成功
    handleSuccess(
      response,
      file,
      fileList,
      property,
      isArray,
      isReadIdInfoAfter,
      readIdInfoAfterToView
    ) {
      this.$emit(
        'handleSuccess',
        response,
        file,
        fileList,
        property,
        isArray,
        isReadIdInfoAfter,
        readIdInfoAfterToView
      )
    },
    //文件格式错误
    handleFormatError(file) {
      this.$emit('handleFormatError', file)
    },
    //文件预览
    handlePreview(file) {
      this.$emit('handlePreview', file)
    },
    //预览
    handleView(guid) {
      this.$emit('handleView', guid)
    },
    //
    updateProgress(event, file, fileList, name) {
      // this.percent = fileInfo.percent * 0.01
      this.$refs[name + 'Upload'].style.display = 'none'
      this.$refs[name].updateShow(true)
      this.$refs[name].updateProgress(Math.round(event.percent)) //=fileInfo.percent * 0.01

      this.$refs[name + 'Upload'].show = event.percent == 100
      // if (event.percent == 100) {
      //   this.$refs[name].updateShow(false)
      //   this.$refs[name + 'Upload'].style.display = 'block'
      // }
    },
  },
}
</script>
<style scoped>
.description {
  padding: 5px 10px;
  border-radius: 5px;
  border: 1px solid #dcdee2;
  min-height: 90px;
}
</style>
